import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import Home from "@/pages/Home";
import Ministry from "@/pages/Ministry";
import Events from "@/pages/Events";
import LeadershipPage from "@/pages/LeadershipPage";
import ScrollToTop from "@/components/site/ScrollToTop";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/ministerios/:slug" element={<Ministry />} />
            <Route path="/eventos" element={<Events />} />
            <Route path="/lideranca" element={<LeadershipPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#ffffff",
              border: "1px solid rgba(212, 175, 55, 0.3)",
              borderRadius: "0px",
            },
          }}
        />
      </div>
    </ThemeProvider>
  );
}

export default App;
